export default __webpack_public_path__ + "static/media/itembag_foodbank.64dad151.png";